import { fontText, hexToRgbA, StylesIndexInjections } from "common-react";
import { fieldBoxShadow, focusStyle } from "../../styles/mixins";
import { createStyles, makeUiStyles, Theme } from "../../styles/styles";
import arrowDownIcon from 'common-assets/assets/icons/arrowDownOrange.svg';
import { themeColorsRgba } from "../../theme/tools/theme.utils";

export default makeUiStyles((theme: Theme) => createStyles({
  root: {
    '& .MuiInputLabel-root': {
      marginBottom: 8,
    },
    '& .special-label': {
      display: 'block',
      font: fontText('normal', theme.fontSize.base, 24),
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      marginLeft: 2,
      pointerEvents: 'none',
      backgroundColor: 'transparent',
    },
  },
  inputWrapper: {
    font: fontText('normal', theme.fontSize.base, 24),
    color: theme.color.greys[80],
    cursor: 'auto',
    'input[type=tel]&': {
      height: 56,
      width: 'auto',
      padding: 16,
      marginLeft: 0,
      borderRadius: ' 0 8px 8px 0',
      border: `1px solid ${theme.color.greys[40]}`,
      borderLeft: 'none',
      outline: 'none',
      appearance: 'none',
      backgroundColor: 'transparent',
      font: fontText('normal', theme.fontSize.base, 24),

      '&:focus': {
        boxShadow: fieldBoxShadow(theme).bs1,
        borderColor: theme.color.greys[80],
        caretColor: theme.color.oranges[50],
      },
      '&.Mui-focusVisible': {
        ...focusStyle(theme, 2),
        boxShadow: 'none',
      },
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        height: 56,
      },

      '&:disabled': {
        backgroundColor: 'transparent',
        opacity: 1,
        border: `1px solid ${hexToRgbA(theme.color.greys[40], 0.4)}`,
        color: themeColorsRgba(theme).black40,
        cursor: 'auto',

        '& + .flag-dropdown:hover .selected-flag': {
          backgroundColor: 'transparent',
        },

        '& + div .selected-flag': {
          border: `1px solid ${hexToRgbA(theme.color.greys[40], 0.4)}`,
          borderRight: () =>  0,
          backgroundColor: 'transparent',
          '& .arrow': {
            display: 'none'
          }
        },

        '&:hover + div, &:focus + div': {
          border: 'none'
        },
      },

      '&:hover + div, &:focus + div': {
        borderRight: () => 0,
      },
    },
  },
  inputError: {
    '&input[type=tel]': {
      borderColor: 'transparent',
      '&:hover': {
        border: `1px solid ${theme.color.reds[100]}`,
      },
      '& + .flag-dropdown': {
        border: `1px solid ${theme.color.reds[100]}`,
      }
    },
  },
  dropdownButton: {
    '$isError &': {
      borderColor: `${theme.color.reds[100]} !important`,

    },
    '.flag-dropdown&': {
      borderRight: 0,
      background: 'transparent',
      borderRadius: 2,
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,

      '&.open .selected-flag': {
        backgroundColor: 'transparent',
        borderRadius: '8px 0px 0px 8px',
        borderWidth: 1
      },

      '& .selected-flag': {
        display: 'flex',
        alignItems: 'center',
        paddingLeft: 16,
        width: 126,
        borderRight: `1px solid ${theme.color.greys[40]}`,
        borderRadius: '8px 0 0 8px',
        '&:focus': {
          backgroundColor: 'transparent',
        },
        '&:hover': {
          background: 'transparent',
        },

        '&:focus-visible': {
          ...focusStyle(theme, 2)
        },

        '& .flag': {
          '& .arrow': {
            left: 70,
            border: 'none',
            width: 24,
            height: 24,
            backgroundImage: `url(${arrowDownIcon})`,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            backgroundSize: '16px 16px',
            top: '50%',
            marginTop: -10,
            '&.up': {
              border: 'none',
            }
          }
        },
      },
    },
  },
  containerWrapper: {
    cursor: 'auto',
    position: 'relative',
    display: 'flex',
    flexDirection: 'row-reverse',
    justifyContent: 'flex-end',
    width: 'max-content',
    '&$isDisabled': {
      pointerEvents: 'none',
      '& .special-label': {
        color: themeColorsRgba(theme).black40,
      },
      '& .selected-flag .flag': {
        opacity: 0.4,
      }
    },
    '&:hover': {
      '& $inputWrapper': {
        boxShadow: fieldBoxShadow(theme).bs1,
        outline: 'none',
        borderColor: theme.color.greys[80],
      },
      '& $dropdownButton': {
        boxShadow: fieldBoxShadow(theme).bs1,
        outline: 'none',
        borderColor: theme.color.greys[80],
      },
      '& .selected-flag': {
        borderWidth: 2,
        borderRightColor: 'transparent',
      }
    },
    '&$isFocusedInput:not(.Mui-focusVisible)': {
      '& $inputWrapper': {
        boxShadow: fieldBoxShadow(theme).bs1,
        outline: 'none',
        borderColor: theme.color.greys[80],
      },
      '& $dropdownButton': {
        boxShadow: fieldBoxShadow(theme).bs1,
        outline: 'none',
        borderColor: theme.color.greys[80],
      },
      '& .selected-flag': {
        borderWidth: 2,
      }
    },
    '& input[type=tel] + div': {
      borderWidth: 1,
      borderColor: theme.color.greys[40],
      borderRight: 'none',
      borderRadius: '8px 0 0 8px',
      position: 'static',
    },
    '& input[type=tel] + div.open': {
      borderTopLeftRadius: 8,
      borderBottomLeftRadius: 8,
      zIndex: 'auto',
    },
    '& input[type=tel]': {

      '&$inputError': {
        outline: 'none',
        borderColor: theme.color.reds[100],
        borderLeft: `1px solid ${theme.color.reds[100]}`,
        '&.Mui-focusVisible': {
          ...focusStyle(theme, 2),
          boxShadow: 'none',
        },
        '&:hover': {
          borderColor: 'transparent',
          outline: `2px solid ${theme.color.greys[80]}`,
          boxShadow: fieldBoxShadow(theme).bs1,
          '& + div': {
            borderColor: 'inherit',
            boxShadow: 'none',
          },
        },
        '&:focus': {
          color: theme.color.greys[80],
          '&:hover': {
            '& + div': {
              border: `1px solid ${theme.color.greys[20]}`,
              borderRight: 'none',
            },
          },
        },

      },
      '&:disabled': {
        '& + div': {
          border: 'none'
        }
      },
    },

    '&:hover input[type=tel]': {
      '&:disabled': {
        '& + div': {
          border: 'none',
        },
        '& + div:hover': {
          border: 'none',
          backgroundColor: theme.color.greys[15],
        }
      },
    },

    '&:hover input[type=tel] + div': {
      borderRight: 0,
    },

    '& input[type=tel] + div:hover': {
      borderRadius: '8px 0 0 8px',
      borderRight: 0,
    },

    '& .no-entries-message': {
      display: 'none',
    },
  },
  countryListWrapper: {
    '&.country-list': {
      backgroundColor: theme.color.greys[0],
      padding: '10px 0',
      maxHeight: 240,
      border: `1px solid ${theme.color.greys[15]}`,
      boxShadow: fieldBoxShadow(theme).bs3,
      borderRadius: 8,
      marginTop: 8,
      overflowY: 'auto',
      width: 'auto',
      left: 0,
      right: -2,
      '& .flag': {
        marginTop: 0,
        marginRight: 16,
      },
      '& .country': {
        display: 'flex',
        alignItems: 'center',
        font: fontText('normal', theme.fontSize.base, 24),
        color: theme.color.greys[80],
        padding: '16px 10px 16px',
        minWidth: 0,
        maxWidth: '100%',
        border: `1px solid ${theme.color.greys[15]}`,
        borderRadius: 8,
        height: 56,
        margin: 4,
        '&:hover': {
          backgroundColor: theme.color.greys[10]
        },

        '& .country-name': {
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        },

        '& .dial-code': {
          color: theme.color.greys[80]
        },

        '&.highlight': {
          border: `2px solid ${theme.color.oranges[50]}`,
          backgroundColor: theme.color.greys[0],
        }
      }
    },
  },
  containerWrapperFullWidth: {
    width: '100%',
    '& input[type=tel]': {
      width: '100%',
    },
  },
  isError: {
    '& $dropdownButton': {
      '& .selected-flag': {
        borderRightColor: 'transparent',
      },
    }
  },
  isFocusedInput: {},
  isDisabled: {},
}), { name: 'PhoneInput', index: StylesIndexInjections.UI_MOLECULES });
